import { useState, useEffect } from "react";
import { Modal, Tooltip, Button } from "antd";
import {
  DownloadOutlined,
  PlusOutlined,
  MinusOutlined,
  ReloadOutlined,
} from "@ant-design/icons";

import error_icon from "../../assets/error_100.png";

const AttachmentPreviewModal = ({ open, attachment, onClose }) => {
  const [scale, setScale] = useState(1);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageError(false);
    resetZoom();
  }, [attachment]);


  if (!attachment) return null;

  const { proof_type, direct_url, file_name, mime_type } = attachment;

  const zoomIn = () => setScale((prev) => Math.min(prev + 0.2, 3));
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.2, 0.5));
  const resetZoom = () => setScale(1);

  const handleWheelZoom = (e) => {
    e.preventDefault();
    if (e.deltaY < 0) zoomIn();
    else zoomOut();
  };

  const isHeic =
    attachment.file_name?.toLowerCase().endsWith(".heic") ||
    attachment.direct_url?.toLowerCase().endsWith(".heic");



  const fallbackNote = (
    <p
      style={{
        marginTop: "8px",
        fontSize: "14px",
        color: "#666",
        fontWeight: "bold",
      }}
    >
      Please download file if you are not able to play it.
    </p>
  );

  const renderPreview = () => {
    switch (true) {
      case proof_type === "PHOTO" || isHeic:
        return (
          <>
            <div style={{ marginBottom: "8px" }}>
              <Tooltip title="Zoom In">
                <Button icon={<PlusOutlined />} onClick={zoomIn} />
              </Tooltip>
              <Tooltip title="Zoom Out">
                <Button
                  icon={<MinusOutlined />}
                  onClick={zoomOut}
                  style={{ margin: "0 8px" }}
                />
              </Tooltip>
              <Tooltip title="Reset">
                <Button icon={<ReloadOutlined />} onClick={resetZoom} />
              </Tooltip>
            </div>

            <div
              style={{
                overflow: "auto",
                maxHeight: "70vh",
                border: "1px solid #eee",
              }}
              onWheel={handleWheelZoom}
            >
              <img
                src={imageError ? error_icon : direct_url}
                alt={file_name}
                onError={() => setImageError(true)}
                style={{
                  transform: `scale(${scale})`,
                  transformOrigin: "center center",
                  transition: "transform 0.2s ease",
                  width: "100%",
                  height: "300px",
                  objectFit: "contain",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </div>
          </>
        );

      case proof_type === "VIDEO":
        return (
          <>
            {fallbackNote}
            <video controls style={{ width: "100%", maxHeight: "70vh" }}>
              <source src={direct_url} type={mime_type} />
            </video>
          </>
        );

      case proof_type === "AUDIO":
        return (
          <>
            {fallbackNote}
            <audio controls style={{ width: "100%" }}>
              <source src={direct_url} type={mime_type} />
            </audio>
          </>
        );

      default:
        return (
          <iframe
            src={direct_url}
            title={file_name}
            style={{
              width: "100%",
              height: "70vh",
              border: "none",
            }}
          />
        );
    }
  };

  return (
    <Modal
      open={open}
      onCancel={() => {
        resetZoom();
        onClose();
      }}
      footer={null}
      centered
      width={900}
      styles={{ body: { padding: "16px" } }}
    >
      <div style={{ textAlign: "center" }}>
        <h4 style={{ marginBottom: "12px" }}>{file_name}</h4>

        {renderPreview()}

        <div style={{ marginTop: "12px" }}>
          <a
            href={direct_url}
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            <Tooltip title="Download">
              <DownloadOutlined style={{ fontSize: 22, cursor: "pointer" }} />
            </Tooltip>
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default AttachmentPreviewModal;
